import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { X } from 'lucide-react';
import { Dialog } from 'radix-ui';

import { Button, ButtonProps } from '@components/primitives';

type DrawerCloseProps =
  | ({ asChild: true } & ComponentPropsWithoutRef<typeof Dialog.Close>)
  | ({ asChild?: false } & ButtonProps);

const DrawerClose = forwardRef<HTMLButtonElement, DrawerCloseProps>(
  function DrawerClose(props, ref) {
    if (props.asChild) {
      return <Dialog.Close ref={ref} data-id="dialog-close" {...props} />;
    }

    const { children, ...buttonProps } = props;

    return (
      <Dialog.Close asChild>
        <Button
          ref={ref}
          type="button"
          size="xs"
          aria-label="Close"
          data-id="dialog-close"
          {...buttonProps}
        >
          {children ?? <X aria-hidden />}
        </Button>
      </Dialog.Close>
    );
  }
);

export default DrawerClose;
